import {Component, OnInit} from "@angular/core";
import {UserCookiesService} from "../user-cookies/user-cookies.service";
import {UserPrivacyService} from "../user-privacy/user-privacy.service";
import {UserRegulationsService} from "../user-regulations/user-regulations.service";

@Component({
    selector: 'pbc-footer',
    templateUrl: './footer.component.html',
})
export class FooterComponent {

    constructor(
      private userPrivacyService : UserPrivacyService,
      private userCookiesService : UserCookiesService,
      private userRegulationsService: UserRegulationsService
    ){}

    showPrivacyClick() {
      this.userPrivacyService.showUserPrivacy.emit(true);
    }

    showCookiesClick() {
      this.userCookiesService.showCookies.emit(true);
    }

    getCurrentYear() : string {
        let currentDate : Date = new Date();
        return currentDate.getFullYear().toString();
    }

    showRegulationsClick() {
        this.userRegulationsService.showUserRegulationsPopup();
    }
}
